<template>
  <RouterLink
    v-slot="{ isActive, href, navigate }"
    :custom="true"
    :to="item.url"
    v-bind="props"
    @click="handleItemClick">
    <a
      :href="href"
      class="relative"
      data-testid="navigationItem"
      :class="
        cn(
          [isActive ? activeClass : inactiveClass],
          itemClass,
          'whitespace-nowrap',
        )
      "
      @click="navigate">
      <template v-if="item.renderFn">
        <component :is="item.renderFn" :item="item" />
      </template>
      <template v-else>{{ item.label }}</template>
      <template v-if="item.hasNewItems">
        <span
          class="-t-0.5 absolute -right-3 text-xs leading-none font-normal text-secondary md:-right-1">
          &#9679;
        </span>
      </template>
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import { cn } from "@dpa-id-components/dpa-shared-components/src/utils/cn.ts";
import { RouterLink, type RouterLinkProps } from "vue-router";

import type { NavigationItem } from "@/composition/shared/useNavigation";

defineOptions({
  inheritAttrs: false,
});

interface AppMenuItemProps extends Pick<
  RouterLinkProps,
  "activeClass" | "exactActiveClass"
> {
  item: NavigationItem;
  itemClass?: string;
  inactiveClass?: string;
}

const props = defineProps<AppMenuItemProps>();

const emit = defineEmits<{
  itemClicked: [];
}>();

function handleItemClick() {
  emit("itemClicked");
  if (props.item.additionalClickHandler) {
    props.item.additionalClickHandler();
  }
}
</script>
